import React from 'react';
import styled from 'styled-components';
import DateHelpers from '../../../../../core/helpers/DateHelper';
import { Icon } from '../../../../components';
import { isSameTime, numberOfDays } from '../eventScheduleDays';
import IDHelpers from '../../../../../core/helpers/IDHelper';

const Container = styled.div.attrs((props: any) => ({
  isCard: props.isCard
}))`
  gap: ${(props) => (props.isCard ? 4 : 8)}px;
  display: flex;
  align-items: flex-start;
  color: #161d1f;
  font-size: ${(props) => (props.isCard ? 12 : 14)}px;
  & div.dates {
    margin-right: 40px;
  }
  & div.dates,
  div.time {
    color: #161d1f;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    gap: 6px;
    display: flex;
    flex-direction: column;
  }
`;

interface Schedule {
  idDay: number;
  startTime: string;
  endTime: string;
}
interface EventScheduleProps {
  isCanceled: boolean;
  isCard?: boolean;
  isOnly: boolean;
  schedule: Schedule[];
  isReservation?: boolean;
}

const EventSchedule: React.FC<EventScheduleProps> = ({
  isCanceled,
  isOnly,
  schedule,
  isCard,
  isReservation
}) => {
  const sortByDay = (a: any, b: any) => a.idDay - b.idDay;
  const days = [...schedule].reverse().sort(sortByDay);
  const numberOfDays1 = numberOfDays(schedule);
  const isSameTime1 = isSameTime(schedule);
  if (isOnly || (numberOfDays1 <= 5 && isSameTime1) || numberOfDays1 === 1)
    return (
      <Container style={{ alignItems: 'center' }} isCard={isCard}>
        {/* <Icon
          name="clock"
          size={isCard ? 14 : 16}
          color={isCanceled === true ? '#8090BB' : '#283044'}
        /> */}
        {isReservation ? (
          <span>
            {schedule[0].startTime} a {schedule[0].endTime}
          </span>
        ) : (
          <span>
            {schedule[0].startTime} - {schedule[0].endTime}
          </span>
        )}
      </Container>
    );
  if (
    isCard &&
    (numberOfDays1 > 5 ||
      isSameTime1 ||
      (numberOfDays1 <= 5 && numberOfDays1 > 1))
  ) {
    return (
      <Container isCard style={{ alignItems: 'center' }}>
        <Icon
          name="clock"
          size={14}
          color={isCanceled === true ? '#8090BB' : '#283044'}
        />
        Varios horarios
      </Container>
    );
  }
  return (
    <Container isCard={isCard}>
      <div className="dates">
        {days.map((sch) => (
          <div key={IDHelpers.generateID()}>
            {DateHelpers.getDayNameOfWeek(sch.idDay, true)}
          </div>
        ))}
      </div>
      <div className="time">
        {days.map((sch) => (
          <div key={IDHelpers.generateID()}>
            {sch.startTime} - {sch.endTime}
          </div>
        ))}
      </div>
    </Container>
  );
};

EventSchedule.defaultProps = {
  isCard: false
};

export default EventSchedule;
